import type {
	useContentContributorsDetailsPanelContentContributorsQuery_contentContributors_ContentContributors_nodes as Nodes,
	useContentContributorsDetailsPanelContentContributorsQuery_contentContributors_ContentContributors_nodes_KnownUser as KnownUser,
} from './hooks/__types__/useContentContributorsDetailsPanelContentContributorsQuery';

export const hasAccountId = (ownedBy?: Nodes | null): ownedBy is KnownUser =>
	!!ownedBy && 'accountId' in ownedBy;

//TODO Move this logic to @confluence/profile once this PR is merged and we update the component in CreatorRow: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/163767/overview
export const truncateName = (name: string, maxChar: number) => {
	if (name.length <= maxChar) {
		return name;
	}

	return `${name.slice(0, maxChar)}...`;
};
